export class RoleAccessModel {
	public id: string;
	public code: string;
	public parentCode: string;
	public description: string;
	public subAccess: RoleAccessModel[];
	public level: number;

	public convert(dto: any, level: number): RoleAccessModel {
		this.level = level;

		if (dto.ID) {
			this.id = dto.ID;
		}
		if (dto.code) {
			this.code = dto.code;
		}
		if (dto.parentCode) {
			this.parentCode = dto.parentCode;
		}
		if (dto.description) {
			this.description = dto.description;
		}
		if (dto.subAccess) {
			const nextLevel = this.level + 1;

			this.subAccess = dto.subAccess.reduce((result, each) => {
				result.push(new RoleAccessModel().convert(each, nextLevel));
				return result;
			}, []);
		}

		return this;
	}
}
